// Grupos de uma participação às vezes vêm no formato "Cidade · Sexo"
// (ex.: "Tupã · Masculino"). Quando TODOS os grupos seguem esse formato,
// a escolha pode ser feita em 2 passos: primeiro a cidade, depois o sexo.

export interface GrupoDividido {
  cidade: string;
  sexo: string;
}

export function dividirNomeGrupo(nome: string | null | undefined): GrupoDividido | null {
  if (!nome) return null;
  const partes = nome
    .split('·')
    .map((p) => p.trim())
    .filter(Boolean);
  if (partes.length !== 2) return null;
  return { cidade: partes[0], sexo: partes[1] };
}

// Só vale a pena perguntar em 2 passos quando todos os grupos têm "Cidade · Sexo"
// e existe mais de uma cidade e mais de um sexo para escolher.
export function ehGrupoEmDuasEtapas(grupos: { grupo: string | null }[]): boolean {
  if (grupos.length < 2) return false;
  const divididos = grupos.map((g) => dividirNomeGrupo(g.grupo));
  if (divididos.some((d) => d === null)) return false;
  const cidades = new Set(divididos.map((d) => (d as GrupoDividido).cidade));
  const sexos = new Set(divididos.map((d) => (d as GrupoDividido).sexo));
  return cidades.size >= 2 && sexos.size >= 2;
}

// Cidades na ordem em que aparecem nos grupos.
export function cidadesDosGrupos(grupos: { grupo: string | null }[]): string[] {
  const lista: string[] = [];
  grupos.forEach((g) => {
    const dividido = dividirNomeGrupo(g.grupo);
    if (dividido && !lista.includes(dividido.cidade)) lista.push(dividido.cidade);
  });
  return lista;
}

// Sexos disponíveis em uma cidade, na ordem em que aparecem nos grupos.
export function sexosDaCidade(
  grupos: { grupo: string | null }[],
  cidade: string | null,
): string[] {
  if (!cidade) return [];
  const lista: string[] = [];
  grupos.forEach((g) => {
    const dividido = dividirNomeGrupo(g.grupo);
    if (!dividido || dividido.cidade !== cidade) return;
    if (!lista.includes(dividido.sexo)) lista.push(dividido.sexo);
  });
  return lista;
}